// Console UI text, part 2 (settings, storage, inbox, users, shared UI, content editor, settings labels, doc names).
const B = {
  "Unsaved": ["Non enregistré", "Sin guardar"],
  "Use default": ["Valeur par défaut", "Usar valor por defecto"],
  "All changes saved": ["Tout est enregistré", "Todo guardado"],
  "No changes": ["Aucun changement", "Sin cambios"],
  "Choose an option.": ["Choisissez une option.", "Elige una opción."],
  "Use 24-hour time, like 23:00.": ["Format 24 h, par ex. 23:00.", "Formato de 24 h, como 23:00."],
  "Use a full https:// link, or leave empty to hide it.": ["Lien complet en https://, ou vide pour le masquer.", "Usa un enlace https:// completo, o déjalo vacío para ocultarlo."],
  "Enter a value.": ["Saisissez une valeur.", "Escribe un valor."],
  "Enter a whole number.": ["Saisissez un nombre entier.", "Escribe un número entero."],
  "Enter a number.": ["Saisissez un nombre.", "Escribe un número."],
  "Other": ["Autres", "Otros"],
  "Tune limits and timings across the app. Changes apply right away.": ["Ajustez les limites et délais de l'app. Les changements s'appliquent immédiatement.", "Ajusta límites y tiempos de la app. Los cambios se aplican al momento."],
  "Save changes": ["Enregistrer", "Guardar cambios"],
  "Where media is stored": ["Où sont stockés les médias", "Dónde se guardan los medios"],
  "Files by type": ["Fichiers par type", "Archivos por tipo"],
  "Deletion queue": ["File de suppression", "Cola de eliminación"],
  "Recent deletions": ["Suppressions récentes", "Eliminaciones recientes"],
  "File": ["Fichier", "Archivo"],
  "Rule": ["Règle", "Regla"],
  "Old storage": ["Ancien stockage", "Almacenamiento antiguo"],
  "Nothing scheduled": ["Rien de prévu", "Nada programado"],
  "No deletions yet": ["Aucune suppression", "Aún no hay eliminaciones"],
  "Files the job deletes show here (latest 100).": ["Les fichiers supprimés par la tâche apparaissent ici (100 derniers).", "Aquí aparecen los archivos que elimina la tarea (últimos 100)."],
  "Only the Owner can see storage.": ["Seul le propriétaire voit le stockage.", "Solo el propietario ve el almacenamiento."],
  "Where member media lives, what gets deleted and when.": ["Où vivent les médias des membres, ce qui est supprimé et quand.", "Dónde están los medios de los miembros, qué se elimina y cuándo."],
  "Test": ["Test", "Prueba"],
  "Reply by email": ["Répondre par e-mail", "Responder por correo"],
  "Search name, email or message": ["Rechercher un nom, un e-mail ou un message", "Buscar nombre, correo o mensaje"],
  "Search": ["Rechercher", "Buscar"],
  "(real senders)": ["(vrais expéditeurs)", "(remitentes reales)"],
  "Topic": ["Sujet", "Tema"],
  "Message": ["Message", "Mensaje"],
  "General": ["Général", "General"],
  "Problem": ["Problème", "Problema"],
  "Press": ["Presse", "Prensa"],
  "Emailed to the team": ["Envoyé à l'équipe par e-mail", "Enviado al equipo por correo"],
  "Logged, not emailed": ["Enregistré, non envoyé", "Registrado, no enviado"],
  "Mark handled": ["Marquer traité", "Marcar como atendido"],
  "Mark as new": ["Marquer nouveau", "Marcar como nuevo"],
  "Marked handled.": ["Marqué comme traité.", "Marcado como atendido."],
  "Marked as new.": ["Marqué comme nouveau.", "Marcado como nuevo."],
  "Messages from the website contact form. Reply by email, then mark them handled.": ["Messages du formulaire de contact du site. Répondez par e-mail, puis marquez-les traités.", "Mensajes del formulario de contacto del sitio. Responde por correo y márcalos como atendidos."],
  "New": ["Nouveau", "Nuevo"],
  "Handled": ["Traité", "Atendido"],
  "Senders": ["Expéditeurs", "Remitentes"],
  "Real": ["Réels", "Reales"],
  "No messages match": ["Aucun message ne correspond", "Ningún mensaje coincide"],
  "No ban records created on this account.": ["Aucun bannissement créé sur ce compte.", "No hay bloqueos creados en esta cuenta."],
  "Test account": ["Compte de test", "Cuenta de prueba"],
  "Launch grant": ["Accès de lancement", "Concesión de lanzamiento"],
  "Push log": ["Journal des notifications", "Registro de notificaciones"],
  "Warn": ["Avertir", "Advertir"],
  "No moderation actions for your role": ["Aucune action de modération pour votre rôle", "No hay acciones de moderación para tu rol"],
  "All users": ["Tous les utilisateurs", "Todos los usuarios"],
  "Active bans": ["Bannissements actifs", "Bloqueos activos"],
  "Every active phone or device ban that matches this person, including bans made on other accounts.": ["Chaque bannissement actif de téléphone ou d'appareil lié à cette personne, y compris sur d'autres comptes.", "Cada bloqueo activo de teléfono o dispositivo que coincide con esta persona, incluidos los de otras cuentas."],
  "Ban records on this account": ["Bannissements sur ce compte", "Bloqueos en esta cuenta"],
  "Lifted": ["Levé", "Levantado"],
  "Profile": ["Profil", "Perfil"],
  "Tier and grants": ["Formule et accès", "Plan y concesiones"],
  "Purchases": ["Achats", "Compras"],
  "Devices": ["Appareils", "Dispositivos"],
  "Notes": ["Notes", "Notas"],
  "No name yet": ["Pas encore de nom", "Aún sin nombre"],
  "Name, phone, email or user ID": ["Nom, téléphone, e-mail ou ID", "Nombre, teléfono, correo o ID"],
  "All statuses": ["Tous les statuts", "Todos los estados"],
  "Banned": ["Banni", "Bloqueado"],
  "Deleted": ["Supprimé", "Eliminado"],
  "Search by first name, phone, recovery email or user ID. Every lookup is recorded in the Admin Log.": ["Recherchez par prénom, téléphone, e-mail de récupération ou ID. Chaque recherche est inscrite au journal admin.", "Busca por nombre, teléfono, correo de recuperación o ID. Cada búsqueda queda en el registro de admin."],
  "No users found": ["Aucun utilisateur trouvé", "No se encontraron usuarios"],
  "Check the number or ID and try again.": ["Vérifiez le numéro ou l'ID et réessayez.", "Revisa el número o el ID e inténtalo de nuevo."],
  "No active bans match this person’s phone or devices.": ["Aucun bannissement actif ne correspond au téléphone ou aux appareils de cette personne.", "Ningún bloqueo activo coincide con el teléfono o los dispositivos de esta persona."],
  "This account": ["Ce compte", "Esta cuenta"],
  "From another account": ["D'un autre compte", "De otra cuenta"],
  "New prompt": ["Nouvelle question", "Nueva pregunta"],
  "Add prompt": ["Ajouter la question", "Añadir pregunta"],
  "This area isn’t part of your role": ["Cette zone ne fait pas partie de votre rôle", "Esta área no forma parte de tu rol"],
  "Something didn’t load": ["Un élément n'a pas pu se charger", "Algo no se cargó"],
  "Try again": ["Réessayer", "Reintentar"],
  "Change password": ["Changer le mot de passe", "Cambiar contraseña"],
  "12+ characters with upper and lower case letters and a number.": ["12 caractères minimum, avec majuscules, minuscules et un chiffre.", "12+ caracteres con mayúsculas, minúsculas y un número."],
  "Current password": ["Mot de passe actuel", "Contraseña actual"],
  "New password": ["Nouveau mot de passe", "Contraseña nueva"],
  "Not strong enough yet.": ["Pas encore assez robuste.", "Aún no es lo bastante segura."],
  "Password updated.": ["Mot de passe mis à jour.", "Contraseña actualizada."],
  "Update password": ["Mettre à jour", "Actualizar contraseña"],
  "Remove test region": ["Retirer la région de test", "Quitar región de prueba"],
  "Text-message (SMS) check": ["Vérification SMS", "Revisión de SMS"],
  "Provider in use:": ["Fournisseur utilisé :", "Proveedor en uso:"],
  "Twilio connection:": ["Connexion Twilio :", "Conexión de Twilio:"],
  "Remove the test ZIP 99999?": ["Retirer le code postal de test 99999 ?", "¿Quitar el código postal de prueba 99999?"],
  "Check IP chain": ["Vérifier la chaîne IP", "Revisar cadena de IP"],
  "Present": ["Présent", "Presente"],
  "Missing": ["Manquant", "Falta"],
  "Run SMS check": ["Lancer la vérification SMS", "Ejecutar revisión de SMS"],
  "Cancel": ["Annuler", "Cancelar"],
  "Working…": ["En cours…", "Trabajando…"],
  "Title": ["Titre", "Título"],
  "Write": ["Écrire", "Escribir"],
  "Preview": ["Aperçu", "Vista previa"],
  "Body": ["Texte", "Texto"],
  "Require users to re-accept": ["Demander une nouvelle acceptation", "Pedir que vuelvan a aceptar"],
  "Everyone is asked to accept this version the next time they open the app.": ["Chacun devra accepter cette version à sa prochaine ouverture de l'app.", "Se pedirá a todos aceptar esta versión la próxima vez que abran la app."],
  "Save as new version": ["Enregistrer une nouvelle version", "Guardar como versión nueva"],
  "Publish": ["Publier", "Publicar"],
  "It goes live now, and everyone will be asked to accept it again.": ["Elle est publiée maintenant, et chacun devra l'accepter à nouveau.", "Se publica ahora y se pedirá a todos aceptarla de nuevo."],
  "It goes live on the website and in the app right away.": ["Elle est publiée immédiatement sur le site et dans l'app.", "Se publica al momento en el sitio y en la app."],
  "No country found.": ["Aucun pays trouvé.", "No se encontró ningún país."],
  "Pick a country": ["Choisir un pays", "Elegir un país"],
  "Search countries": ["Rechercher un pays", "Buscar países"],
  "Sanctioned": ["Sous sanctions", "Sancionado"],
  "Temporary password": ["Mot de passe temporaire", "Contraseña temporal"],
  "Done": ["Terminé", "Listo"],
  "Invite admin": ["Inviter un admin", "Invitar admin"],
  "Invite an admin": ["Inviter un admin", "Invitar a un admin"],
  "Name (optional)": ["Nom (facultatif)", "Nombre (opcional)"],
  "Password (optional)": ["Mot de passe (facultatif)", "Contraseña (opcional)"],
  "Copied.": ["Copié.", "Copiado."],
  "Copy password": ["Copier le mot de passe", "Copiar contraseña"],
  "Inviting…": ["Invitation…", "Invitando…"],
  "Send invite": ["Envoyer l'invitation", "Enviar invitación"],
  "One-time purchases": ["Achats uniques", "Compras únicas"],
  "Bought once, kept forever on the account. Nothing renews.": ["Acheté une fois, conservé pour toujours sur le compte. Sans renouvellement.", "Se compra una vez y queda para siempre en la cuenta. No se renueva."],
  "Dark look (lifetime)": ["Thème sombre (à vie)", "Aspecto oscuro (de por vida)"],
  "Price (USD)": ["Prix (USD)", "Precio (USD)"],
  "Store product ID": ["ID produit store", "ID de producto en tienda"],
  "Check a place": ["Vérifier un lieu", "Revisar un lugar"],
  "See what someone there would get today.": ["Voir ce qu'une personne sur place obtiendrait aujourd'hui.", "Mira qué obtendría hoy alguien de allí."],
  "Country": ["Pays", "País"],
  "City": ["Ville", "Ciudad"],
  "State / province": ["État / province", "Estado / provincia"],
  "Typed postal code": ["Code postal saisi", "Código postal escrito"],
  "Device location": ["Position de l'appareil", "Ubicación del dispositivo"],
  "What the app knows": ["Ce que l'app sait", "Lo que sabe la app"],
  "Not known": ["Inconnu", "Desconocido"],
  "This browser can’t play it.": ["Ce navigateur ne peut pas le lire.", "Este navegador no puede reproducirlo."],
  "Download the file": ["Télécharger le fichier", "Descargar el archivo"],
  "Member": ["Membre", "Miembro"],
  "Save label": ["Enregistrer le libellé", "Guardar etiqueta"],
  "Field": ["Champ", "Campo"],
  "Before": ["Avant", "Antes"],
  "After": ["Après", "Después"],
  "No before/after recorded.": ["Aucun avant/après enregistré.", "No hay antes/después registrado."],
  "Kill switches": ["Arrêts d'urgence", "Interruptores de emergencia"],
  "View only": ["Lecture seule", "Solo lectura"],
  "Stopped": ["Arrêté", "Detenido"],
  "Sending": ["Envoi actif", "Enviando"],
  "Stop sending": ["Arrêter l'envoi", "Detener envío"],
  "Resume sending": ["Reprendre l'envoi", "Reanudar envío"],
  "Test data, not counted above": ["Données de test, non comptées ci-dessus", "Datos de prueba, no contados arriba"],
  "Website": ["Site web", "Sitio web"],
  "Waves sent": ["Vagues envoyées", "Oleadas enviadas"],
  "Referrals used": ["Parrainages utilisés", "Referidos usados"],
  "Signups, last 14 days": ["Inscriptions, 14 derniers jours", "Registros, últimos 14 días"],
  "Matches, last 14 days": ["Matchs, 14 derniers jours", "Matches, últimos 14 días"],
  "Reports open": ["Signalements ouverts", "Denuncias abiertas"],
  "Appeals open": ["Appels ouverts", "Apelaciones abiertas"],
  "No items.": ["Aucun élément.", "Sin elementos."],
  "Add": ["Ajouter", "Añadir"],
  "Already in the list.": ["Déjà dans la liste.", "Ya está en la lista."],
  "Add pack": ["Ajouter un pack", "Añadir paquete"],
  "Quantity": ["Quantité", "Cantidad"],
  "Order": ["Ordre", "Orden"],
  "Badge": ["Badge", "Insignia"],
  "Shown on the pack card in the app.": ["Affiché sur la carte du pack dans l'app.", "Se muestra en la tarjeta del paquete en la app."],
  "Remove pack": ["Retirer le pack", "Quitar paquete"],
  "Ready": ["Prêt", "Listo"],
  "Not ready": ["Pas prêt", "No está listo"],
  "Unknown": ["Inconnu", "Desconocido"],
  "Ready to launch": ["Prêt pour le lancement", "Listo para lanzar"],
  "No photos yet.": ["Pas encore de photos.", "Aún no hay fotos."],
  "No prompts answered yet.": ["Aucune réponse aux questions.", "Aún no ha respondido preguntas."],
  "None set.": ["Rien de défini.", "Nada definido."],
  "Not verified": ["Non vérifié", "No verificado"],
  "Verification selfie": ["Selfie de vérification", "Selfie de verificación"],
  "About": ["À propos", "Acerca de"],
  "Preferences": ["Préférences", "Preferencias"],
  "Age range": ["Tranche d'âge", "Rango de edad"],
  "Distance": ["Distance", "Distancia"],
  "Loading…": ["Chargement…", "Cargando…"],
  "Name": ["Nom", "Nombre"],
  "Starts": ["Début", "Empieza"],
  "Ends": ["Fin", "Termina"],
  "Audience": ["Audience", "Público"],
  "Tier": ["Formule", "Plan"],
  "Store offers": ["Offres des stores", "Ofertas de tienda"],
  "Everyone": ["Tout le monde", "Todos"],
  "Free members": ["Membres gratuits", "Miembros gratis"],
  "Free": ["Gratuit", "Gratis"],
  "Save": ["Enregistrer", "Guardar"],
  "Send log": ["Journal d'envoi", "Registro de envíos"],
  "To": ["Au", "Hasta"],
  "User": ["Utilisateur", "Usuario"],
  "Category": ["Catégorie", "Categoría"],
  "Source": ["Source", "Origen"],
  "Error": ["Erreur", "Error"],
  "Level": ["Niveau", "Nivel"],
  "Label": ["Libellé", "Etiqueta"],
  "(optional)": ["(facultatif)", "(opcional)"],
  "Change history": ["Historique des changements", "Historial de cambios"],
  "No changes yet": ["Aucun changement", "Aún no hay cambios"],
  "Dismiss": ["Classer sans suite", "Descartar"],
  "Dismiss these reports?": ["Classer ces signalements sans suite ?", "¿Descartar estas denuncias?"],
  "Send a warning?": ["Envoyer un avertissement ?", "¿Enviar una advertencia?"],
  "Hide": ["Masquer", "Ocultar"],
  "Hide this profile?": ["Masquer ce profil ?", "¿Ocultar este perfil?"],
  "Remove photos": ["Retirer des photos", "Quitar fotos"],
  "Ban": ["Bannir", "Bloquear"],
  "Ban this account?": ["Bannir ce compte ?", "¿Bloquear esta cuenta?"],
  "Snapshot": ["Instantané", "Captura"],
  "Hidden": ["Masqué", "Oculto"],
  "Voice message": ["Message vocal", "Mensaje de voz"],
  "Reported person": ["Personne signalée", "Persona denunciada"],
  "Reporter": ["Auteur du signalement", "Denunciante"],
  "Show": ["Afficher", "Mostrar"],
  "View-once": ["Vue unique", "Ver una vez"],
  "Media not available for reports filed before this update.": ["Média indisponible pour les signalements antérieurs à cette mise à jour.", "Medio no disponible para denuncias anteriores a esta actualización."],
  "Onboarding verification": ["Vérification d'inscription", "Verificación de registro"],
  "Phone change": ["Changement de numéro", "Cambio de número"],
  "Reviewer access": ["Accès examinateurs", "Acceso para revisores"],
  "Reviewer numbers": ["Numéros des examinateurs", "Números de revisores"],
  "Account exists": ["Compte existant", "La cuenta existe"],
  "No account yet": ["Pas encore de compte", "Aún sin cuenta"],
  "Never signed in": ["Jamais connecté", "Nunca inició sesión"],
  "Recreate demo profiles": ["Recréer les profils de démo", "Recrear perfiles de demostración"],
  "Save numbers": ["Enregistrer les numéros", "Guardar números"],
  "Turn this on before you submit a build for review and off after approval. Every update needs review again.": ["Activez avant de soumettre une version à l'examen, puis désactivez après validation. Chaque mise à jour repasse en examen.", "Actívalo antes de enviar una versión a revisión y desactívalo tras la aprobación. Cada actualización necesita revisión de nuevo."],
  "Turn on reviewer sign-in for Apple and Google review?": ["Activer la connexion examinateurs pour l'examen Apple et Google ?", "¿Activar el acceso de revisores para la revisión de Apple y Google?"],
  "Turn off reviewer sign-in?": ["Désactiver la connexion examinateurs ?", "¿Desactivar el acceso de revisores?"],
  "Store": ["Store", "Tienda"],
  "Price": ["Prix", "Precio"],
  "Period": ["Durée", "Periodo"],
  "Product": ["Produit", "Producto"],
  "Grant tier": ["Accorder une formule", "Conceder plan"],
  "Permanent": ["Permanent", "Permanente"],
  "Revoke": ["Révoquer", "Revocar"],
  "Default": ["Par défaut", "Por defecto"],
  "Unban": ["Lever le bannissement", "Desbloquear"],
  "Unhide": ["Réafficher", "Mostrar de nuevo"],
  "Ban user": ["Bannir l'utilisateur", "Bloquear usuario"],
  "User banned.": ["Utilisateur banni.", "Usuario bloqueado."],
  "Ban lifted.": ["Bannissement levé.", "Bloqueo levantado."],
  "Profile hidden.": ["Profil masqué.", "Perfil oculto."],
  "Profile is visible again.": ["Le profil est de nouveau visible.", "El perfil vuelve a ser visible."],
  "Details": ["Détails", "Detalles"],
  "Date of birth": ["Date de naissance", "Fecha de nacimiento"],
  "Joined": ["Inscrit", "Se unió"],
  "Recovery email": ["E-mail de récupération", "Correo de recuperación"],
  "View full profile": ["Voir le profil complet", "Ver perfil completo"],
  "Version history": ["Historique des versions", "Historial de versiones"],
  "Re-accept": ["Nouvelle acceptation", "Volver a aceptar"],
  "View": ["Voir", "Ver"],
  "Load into editor": ["Charger dans l'éditeur", "Cargar en el editor"],
  "Woman": ["Femme", "Mujer"],
  "Man": ["Homme", "Hombre"],
  "Nonbinary": ["Non binaire", "No binario"],
  "Prefer not to say": ["Je préfère ne pas le dire", "Prefiero no decirlo"],
  // Settings groups
  "Allowances": ["Quotas", "Cupos"],
  "Matching": ["Mise en relation", "Emparejamiento"],
  "Discover": ["Découvrir", "Descubrir"],
  "Chat": ["Chat", "Chat"],
  "Safety": ["Sécurité", "Seguridad"],
  "Account": ["Compte", "Cuenta"],
  "Photo screening": ["Contrôle des photos", "Revisión de fotos"],
  "Team & data": ["Équipe et données", "Equipo y datos"],
  "Appearance": ["Apparence", "Apariencia"],
  "Settings without a group yet.": ["Réglages pas encore classés.", "Ajustes aún sin grupo."],
  // Content docs
  "Terms of Service": ["Conditions d'utilisation", "Términos del servicio"],
  "Privacy Policy": ["Politique de confidentialité", "Política de privacidad"],
  "Chat safety tips": ["Conseils de sécurité du chat", "Consejos de seguridad del chat"],
  "Warning message": ["Message d'avertissement", "Mensaje de advertencia"],
  "Push notification copy": ["Textes des notifications", "Textos de notificaciones"],
  "Eligibility sentence": ["Phrase d'éligibilité", "Frase de elegibilidad"],
  "Not-in-area message": ["Message hors zone", "Mensaje fuera de zona"],
  "Support URL": ["URL d'assistance", "URL de soporte"],
  "Tagline": ["Slogan", "Eslogan"],
  "Website: Home": ["Site : Accueil", "Sitio: Inicio"],
  "Website: How it works": ["Site : Comment ça marche", "Sitio: Cómo funciona"],
  "Website: Plans": ["Site : Formules", "Sitio: Planes"],
  "Website: Safety": ["Site : Sécurité", "Sitio: Seguridad"],
  "Website: Support": ["Site : Assistance", "Sitio: Ayuda"],
  "Website: Footer": ["Site : Pied de page", "Sitio: Pie de página"],
  "Community guidelines": ["Règles de la communauté", "Normas de la comunidad"],
  "Photo restored notice": ["Avis de photo restaurée", "Aviso de foto restaurada"],
  "Wave invite email": ["E-mail d'invitation de vague", "Correo de invitación por oleada"],
  "App links": ["Liens de l'app", "Enlaces de la app"],
  "Referral share text": ["Texte de parrainage", "Texto para compartir referido"],
  "Verification retake notice": ["Avis de nouveau selfie", "Aviso de nueva selfie"],
  "Team invite email": ["E-mail d'invitation d'équipe", "Correo de invitación al equipo"],
  "Privacy: Face data": ["Confidentialité : données faciales", "Privacidad: datos faciales"],
  "Hard no warnings": ["Avertissements « hard no »", "Advertencias de «hard no»"],
  "Selfie check: consent": ["Vérif. selfie : consentement", "Revisión de selfie: consentimiento"],
  "Selfie check: buttons": ["Vérif. selfie : boutons", "Revisión de selfie: botones"],
  "Fake profile": ["Faux profil", "Perfil falso"],
  "Inappropriate photos": ["Photos inappropriées", "Fotos inapropiadas"],
  "Harassment or abuse": ["Harcèlement ou abus", "Acoso o abuso"],
  "Scam or asking for money": ["Arnaque ou demande d'argent", "Estafa o pide dinero"],
  "Breaking our community guidelines": ["Non-respect des règles de la communauté", "Incumple las normas de la comunidad"],
  // Content editor: translations
  "Complete": ["Complet", "Completo"],
  "Empty": ["Vide", "Vacío"],
  "Missing {x}": ["{x} manquant(s)", "Faltan {x}"],
  "Draft — needs review": ["Brouillon — à relire", "Borrador — requiere revisión"],
  "Mark reviewed": ["Marquer comme relu", "Marcar como revisado"],
  "Mark this version reviewed?": ["Marquer cette version comme relue ?", "¿Marcar esta versión como revisada?"],
  "Members and the website get this version instead of the English one.": ["Les membres et le site recevront cette version au lieu de l'anglaise.", "Los miembros y el sitio recibirán esta versión en lugar de la inglesa."],
  "Marked reviewed. It's now served in this language.": ["Marqué comme relu. Cette version est maintenant servie.", "Marcado como revisado. Ahora se sirve en este idioma."],
  "Translate missing (AI draft)": ["Traduire les manques (brouillon IA)", "Traducir lo que falta (borrador IA)"],
  "Translating…": ["Traduction…", "Traduciendo…"],
  "AI drafts fill only what's missing or outdated. They never replace a person's save.": ["Les brouillons IA ne complètent que ce qui manque ou est périmé. Ils ne remplacent jamais une saisie humaine.", "Los borradores IA solo completan lo que falta o está desactualizado. Nunca reemplazan lo guardado por una persona."],
  "Translation run finished.": ["Traduction terminée.", "Traducción terminada."],
  "Translation run failed.": ["La traduction a échoué.", "La traducción falló."],
  "Translation run started.": ["Traduction lancée.", "Traducción iniciada."],
  "translated": ["traduits", "traducidos"],
  "kept (human)": ["conservés (humain)", "conservados (persona)"],
  "already current": ["déjà à jour", "ya al día"],
  "rejected": ["rejetés", "rechazados"],
  "need review": ["à relire", "por revisar"],
  "Running": ["En cours", "En curso"],
  "Finished": ["Terminé", "Terminado"],
  "Failed": ["Échec", "Falló"],
  "Needs translation": ["À traduire", "Por traducir"],
  "All documents": ["Tous les documents", "Todos los documentos"],
  "Nothing needs translation.": ["Rien à traduire.", "No hay nada por traducir."],
  "AI draft": ["Brouillon IA", "Borrador IA"],
  "Edited by a person": ["Modifié par une personne", "Editado por una persona"],
  "English changed since": ["L'anglais a changé depuis", "El inglés cambió desde entonces"],
  "Missing keys (English shows for these):": ["Clés manquantes (l'anglais s'affiche) :", "Claves que faltan (se muestra el inglés):"],
  "One “key: text” per line. Only include the keys you translate; the rest show English.": ["Une ligne « clé: texte » par clé. N'incluez que les clés traduites ; les autres restent en anglais.", "Una línea «clave: texto» por clave. Incluye solo las que traduces; el resto se muestra en inglés."],
  "Empty: English shows until you add text.": ["Vide : l'anglais s'affiche tant que vous n'ajoutez pas de texte.", "Vacío: se muestra el inglés hasta que añadas texto."],
  "Save translation": ["Enregistrer la traduction", "Guardar traducción"],
  "Reviewed by a person (goes live)": ["Relu par une personne (publié)", "Revisado por una persona (se publica)"],
  "Legal text: without this, members keep seeing English until it's marked reviewed.": ["Texte juridique : sans cela, les membres voient l'anglais tant que ce n'est pas marqué relu.", "Texto legal: sin esto, los miembros siguen viendo el inglés hasta marcarlo como revisado."],
  "No versions yet.": ["Aucune version.", "Aún no hay versiones."],
  "Saved by {x} on {x}": ["Enregistré par {x} le {x}", "Guardado por {x} el {x}"],
  "English comes from the Prompts and Interests pages.": ["L'anglais vient des pages Questions et Centres d'intérêt.", "El inglés viene de las páginas Preguntas e Intereses."],
  "Placeholders differ from English: {x}": ["Les variables diffèrent de l'anglais : {x}", "Los marcadores difieren del inglés: {x}"],
  "Saved {x} as version {x}.": ["{x} enregistré en version {x}.", "{x} guardado como versión {x}."],
  "Publish {x} v{x}?": ["Publier {x} v{x} ?", "¿Publicar {x} v{x}?"],
  "Loaded v{x} into the editor. Save to publish it.": ["v{x} chargée dans l'éditeur. Enregistrez pour la publier.", "v{x} cargada en el editor. Guarda para publicarla."],
  "Live: v{x}": ["En ligne : v{x}", "Publicado: v{x}"],
  "Live: v": ["En ligne : v", "Publicado: v"],
  // Found by the FR page scan
  "Views by page": ["Vues par page", "Vistas por página"],
  "No views yet.": ["Aucune vue pour l'instant.", "Aún no hay vistas."],
  "Page views, 14 days": ["Pages vues, 14 jours", "Páginas vistas, 14 días"],
  "Waitlist conversion": ["Conversion de la liste d'attente", "Conversión de la lista de espera"],
  "Mock": ["Simulé", "Simulado"],
  "Test:": ["Test :", "Prueba:"],
  "As of": ["Au", "A fecha de"],
  "Underage": ["Mineur", "Menor de edad"],
  "No pending appeals": ["Aucun appel en attente", "No hay apelaciones pendientes"],
  "Show test accounts": ["Afficher les comptes de test", "Mostrar cuentas de prueba"],
  "Rejected uploads are kept privately for": ["Les envois refusés sont conservés en privé pendant", "Las subidas rechazadas se guardan en privado durante"],
  "Uploaded": ["Publié le", "Subido el"],
  "Reviewed by": ["Examiné par", "Revisado por"],
  "Release a batch": ["Libérer un lot", "Liberar un lote"],
  "Any country": ["Tous les pays", "Cualquier país"],
  "Postal codes": ["Codes postaux", "Códigos postales"],
  "Postal code": ["Code postal", "Código postal"],
  "How many": ["Combien", "Cuántos"],
  "Keep gender balanced": ["Garder l'équilibre des genres", "Mantener el equilibrio de género"],
  "Release": ["Libérer", "Liberar"],
  "Released": ["Libérés", "Liberados"],
  "Email contains": ["L'e-mail contient", "El correo contiene"],
  "Gender": ["Genre", "Género"],
  "Addresses": ["Adresses", "Direcciones"],
  "Gender split": ["Répartition par genre", "Reparto por género"],
  "By postal code": ["Par code postal", "Por código postal"],
  "Into": ["Dans", "En"],
  "Import postal codes": ["Importer des codes postaux", "Importar códigos postales"],
  "Add offer": ["Ajouter une offre", "Añadir oferta"],
  "No store offers yet.": ["Aucune offre pour l'instant.", "Aún no hay ofertas de tienda."],
  "First messages from new matches": ["Premiers messages des nouveaux matchs", "Primeros mensajes de matches nuevos"],
  "Replies after a quiet day": ["Réponses après une journée calme", "Respuestas tras un día tranquilo"],
  "Photo likes from matches": ["J'aime sur les photos (matchs)", "Me gusta en fotos de matches"],
  "New photos from matches": ["Nouvelles photos des matchs", "Fotos nuevas de matches"],
  "Safety and account updates": ["Sécurité et compte", "Seguridad y cuenta"],
  "Send a test push": ["Envoyer une notification de test", "Enviar una notificación de prueba"],
  "Send test push": ["Envoyer le test", "Enviar prueba"],
  "Skip the rules": ["Ignorer les règles", "Saltar las reglas"],
  "Set": ["Défini", "Definido"],
  "Not set yet": ["Pas encore défini", "Aún sin definir"],
  "Daily crushes": ["Crushes par jour", "Crushes diarios"],
  "Daily winks": ["Winks par jour", "Winks diarios"],
  "Show people active in the last": ["Montrer les personnes actives depuis", "Mostrar personas activas en los últimos"],
  "Default search distance": ["Distance de recherche par défaut", "Distancia de búsqueda por defecto"],
  "Largest distance someone can choose": ["Distance maximale au choix", "Distancia máxima que se puede elegir"],
  "Boost for newer profiles": ["Coup de pouce aux nouveaux profils", "Impulso a perfiles nuevos"],
  "Window for counting those reports": ["Période de décompte de ces signalements", "Periodo para contar esas denuncias"],
  "Chat messages attached to a report": ["Messages joints à un signalement", "Mensajes adjuntos a una denuncia"],
  "Reporters needed to auto-hide a profile": ["Signalements nécessaires pour masquer un profil", "Denunciantes necesarios para ocultar un perfil"],
  "Minimum age (18 is the floor)": ["Âge minimum (18 au moins)", "Edad mínima (18 como mínimo)"],
  "Maximum age": ["Âge maximum", "Edad máxima"],
  "Store mode": ["Mode des stores", "Modo de tienda"],
  "Text message provider": ["Fournisseur SMS", "Proveedor de SMS"],
  "Daily Crushes and Winks, how fast they refill, and Crush note length.": ["Crushes et Winks quotidiens, leur recharge et la longueur des mots de Crush.", "Crushes y Winks diarios, su recarga y la longitud de la nota del Crush."],
  "Who shows up in Discover, how far away, and how much newer profiles are favored.": ["Qui apparaît dans Découvrir, à quelle distance, et l'avantage donné aux nouveaux profils.", "Quién aparece en Descubrir, a qué distancia y cuánto se favorece a los perfiles nuevos."],
  "Reports, auto-hide, bans and appeals, and selfie retakes.": ["Signalements, masquage auto, bannissements, appels et nouveaux selfies.", "Denuncias, ocultación automática, bloqueos, apelaciones y nuevas selfies."],
  "Phone number changes and account deletion.": ["Changements de numéro et suppression de compte.", "Cambios de número y eliminación de cuenta."],
};
export default B;
